import {Component, EventEmitter, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MatRadioChange} from '@angular/material/radio';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import _ from 'lodash';

@Component({
  selector: 'prefix-groups-search',
  templateUrl: './prefix-groups-search.component.html',
  styleUrls: ['./prefix-groups-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PrefixGroupsSearchComponent implements OnInit {

  onApply = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<PrefixGroupsSearchComponent>, @Inject(MAT_DIALOG_DATA) public search: any) {
  }

  ngOnInit(): void {
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.dialogRef.close();

    if (_.isEqual(this.search.searchType, 'VALUE')) {
      delete this.search.match;
    } else {
      delete this.search.value;
    }

    this.onApply.emit(this.search);
  }

  searchTypeChange(change: MatRadioChange): void {
    if (_.isNil(change.value)) {
      return;
    }

    if (change.value === 'MATCH') {
      this.search.value = '';
    } else {
      this.search.match = '';
    }
  }
}
